export const EMPTY_STATE_DESCRIPTION_CLASS = 'empty-state__description';
